import { FacturaRecurrenteReadingFiltersDtoProps } from "api/DTOs/FacturaRecurrenteReadingFiltersDto"
import {
  CuentaContableTemplate,
  EstadoFacturaRecurrente,
  FechaRecurrentesTemplate,
  ImporteBodyTemplate,
  IntervalosRecurrentesTemplate,
} from "features/Documentos/templates"
import { TFunction } from "i18next"
import { FECHAS_RECURRENTES_KEYS } from "./pages/FacturasRecurrentesDetail/constants"

export const FACTURAS_RECURRENTES_COLUMNS = ({ t }: { t: TFunction }) => {
  const columns = [
    {
      header: t("documentos.facturaRec.tab.headerCompanyName"),
      field: "razonSocialLibrado",
      key: "razonSocialLibrado",
      sortable: true,
      sortField: "Librado.RazonSocial",
    },
    {
      header: t("documentos.facturaRec.tab.headerState"),
      field: "estado",
      key: "estado",
      style: { width: 140 },
      sortable: true,
      sortField: "DocumentoRecurrente_Intervalo.Estado",
      body: ({ estado, id }: FacturaRecurrenteReadingFiltersDtoProps) =>
        estado ? EstadoFacturaRecurrente(estado, id) : "-",
    },
    {
      header: t("documentos.facturaRec.tab.headerInterval"),
      key: "intervalo",
      field: "intervalo",
      body: (rowData: FacturaRecurrenteReadingFiltersDtoProps) =>
        IntervalosRecurrentesTemplate(rowData, t),
      sortable: true,
      sortField: "DocumentoRecurrente_Intervalo.Intervalo",
    },
    {
      header: t("documentos.facturaRec.tab.headerInit"),
      field: "fechaInicio",
      key: "fechaInicio",
      body: (rowData: FacturaRecurrenteReadingFiltersDtoProps) =>
        FechaRecurrentesTemplate(rowData, FECHAS_RECURRENTES_KEYS.fechaInicio),
      sortable: true,
      sortField: "DocumentoRecurrente_Intervalo.FechaInicio",
    },
    {
      header: t("documentos.facturaRec.tab.headerFinal"),
      field: "fechaFin",
      key: "fechaFin",
      body: (rowData: FacturaRecurrenteReadingFiltersDtoProps) =>
        FechaRecurrentesTemplate(rowData, FECHAS_RECURRENTES_KEYS.fechaFin),
      sortable: true,
      sortField: "DocumentoRecurrente_Intervalo.FechaFin",
    },
    {
      header: t("documentos.facturaRec.tab.headerSig"),
      field: "fechaProximaFactura",
      key: "fechaProximaFactura",
      body: (rowData: FacturaRecurrenteReadingFiltersDtoProps) =>
        FechaRecurrentesTemplate(
          rowData,
          FECHAS_RECURRENTES_KEYS.fechaProximaFactura
        ),
      sortable: true,
      sortField: "DocumentoRecurrente_Intervalo.FechaProximoDocumento",
    },
    {
      header: t("documentos.facturaRec.tab.headerAccountingAccount"),
      field: "cuentaContable",
      key: "cuentaContable",
      body: CuentaContableTemplate,
      sortable: true,
      sortField: "CuentaContableFactura.CategoriaLibrador.Numero",
    },
    {
      header: t("documentos.facturaRec.tab.headerTax"),
      field: "importe",
      key: "importe",
      className: "!tw-text-end",
      body: ImporteBodyTemplate,
      sortable: true,
      alignCol: "right",
      sortField: "Importe",
    },
  ]
  return columns
}
